<h2 *ngIf="listType === lt.CampaignList" mat-dialog-title>
  {{ 'LISTS.CAMPAIGN_DIALOG.ADD_LIST_TO_CAMPAIGN_TITLE' | translate: { campaignName: campaignName } }}
</h2>
<ng-container *ngIf="listType === lt.AccountList || listType === lt.UserList">
  <h2 mat-dialog-title>
    {{ 'LISTS.CAMPAIGN_DIALOG.TITLE' | translate: { name: listName } }}
  </h2>
</ng-container>
<mat-dialog-content class="dialog--overflow dialogHeight">
  <div *ngIf="listType === lt.CampaignList" class="modal-subheader">
    {{ 'LISTS.CAMPAIGN_DIALOG.LIST_SELECTION' | translate }}
  </div>
  <div *ngIf="listType === lt.AccountList || listType === lt.UserList" class="modal-subheader">
    {{ 'LISTS.CAMPAIGN_DIALOG.CAMPAIGN_SELECTION' | translate }}
  </div>
  <mat-divider></mat-divider>

  <ng-container *ngIf="listType !== lt.CampaignList">
    <glxy-form-field [style.display]="selectedCampaign ? 'none' : 'initial'">
      <glxy-label>Search by campaign name</glxy-label>
      <input type="name" #nameBox matInput (keyup)="handleCampaignSearchChange(nameBox.value)" />
    </glxy-form-field>
  </ng-container>

  <glxy-loading-spinner *ngIf="campaignsLoading"></glxy-loading-spinner>

  <ng-container *ngIf="!campaignsLoading">
    <ng-container *ngIf="(campaigns || []).length > 0" class="modal-section">
      <p *ngIf="listType === lt.AccountList">
        {{ 'LISTS.CAMPAIGN_DIALOG.ACCOUNT_LIST_DESCRIPTOR' | translate }}
      </p>
      <ng-template *ngIf="listType === lt.UserList">
        <p>
          {{ 'LISTS.CAMPAIGN_DIALOG.USER_LIST_DESCRIPTOR' | translate }}
        </p>
      </ng-template>

      <ng-container *ngIf="listType !== lt.CampaignList">
        <ng-container *ngIf="!selectedCampaign">
          <mat-selection-list
            class="campaignsList"
            [multiple]="false"
            (selectionChange)="handleCampaignSelectionChange($event)"
          >
            <mat-list-option *ngFor="let c of campaigns" [value]="c">
              {{ c.name }}
            </mat-list-option>
          </mat-selection-list>
        </ng-container>
        <ng-container *ngIf="selectedCampaign">
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>Selected Campaign</mat-card-title>
              <mat-card-subtitle>{{ selectedCampaign.name }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-actions align="end">
              <button mat-button (click)="cancelCampaignSelection()">Cancel</button>
            </mat-card-actions>
          </mat-card>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="listType === lt.CampaignList">
        <uikit-search-select
          [options]="availableActionLists"
          [showSearch]="true"
          placeholderText="{{ 'LISTS.CAMPAIGN_DIALOG.LIST_SELECTION' | translate }}"
          [displayProperty]="'name'"
          [selected]="selectedActionList"
          [width]="400"
          (selection)="actionListSelected($event)"
        ></uikit-search-select>
      </ng-container>

      <div *ngIf="showSnapshotConsent$ | async" class="modal-section">
        <p>
          {{ 'LISTS.CAMPAIGN_DIALOG.SNAPSHOT.WARNING' | translate }}
        </p>
        <mat-checkbox id="confirmBox" [(ngModel)]="isConfirmed"></mat-checkbox>
        <div id="snapshotWarning" [ngStyle]="{ color: isConfirmed ? 'black' : 'dimgray' }">
          <span>
            {{
              'LISTS.CAMPAIGN_DIALOG.SNAPSHOT.TERMS'
                | translate: { list: listName, campaign: selectedCampaign?.name ?? '' }
            }}
          </span>
          <a *ngIf="!showInfo" (click)="showInfo = true">
            {{ 'COMMON.ACTION_LABELS.LEARN_MORE' | translate }}
          </a>
          <p *ngIf="showInfo">
            {{ 'LISTS.CAMPAIGN_DIALOG.SNAPSHOT.INFO' | translate }}
          </p>
        </div>
      </div>
      <ng-container *ngIf="selectedCampaign || selectedActionList">
        <div class="modal-subheader" style="margin-top: 24px">
          {{ 'LISTS.CAMPAIGN_DIALOG.SCHEDULE_CAMPAIGN_SUBTITLE' | translate }}
        </div>
        <mat-divider></mat-divider>
        <div class="alert-warning modal-section">
          <mat-spinner [strokeWidth]="4" [diameter]="24" *ngIf="campaignStartLoading"></mat-spinner>
          <ng-container *ngIf="!campaignStartLoading">
            {{ 'LISTS.CAMPAIGN_DIALOG.START_DATE' | translate }}
            <div id="startDate">
              <strong>{{ campaignStart | glxyDate: DateFormat.long }} ({{ selectedCampaignTimezone }})</strong>
            </div>
            <div>
              <ng-container *ngIf="!showScheduledStartPicker">
                <a
                  id="scheduleBtn"
                  *ngIf="(selectedCampaign || selectedActionList) && !campaignStartLoading"
                  (click)="onScheduleCampaignClick()"
                >
                  <mat-icon>date_range</mat-icon>
                  {{ 'LISTS.CAMPAIGN_DIALOG.DATE_SELECT' | translate }}
                </a>
              </ng-container>
              <span id="schedulePicker" *ngIf="showScheduledStartPicker">
                <app-datetime-picker
                  [datetime]="scheduledStart"
                  [allowDatesInPast]="false"
                  (datetimeChanged)="onScheduledStartChange($event)"
                  (invalidDate)="validDate = !$event"
                ></app-datetime-picker>
                <a id="cancelBtn" (click)="onScheduleCampaignClick()">
                  <mat-icon>cancel</mat-icon>
                </a>
              </span>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="(campaigns || []).length === 0">
      <p>
        {{ 'LISTS.CAMPAIGN_DIALOG.NO_CAMPAIGNS' | translate }}
        <a [href]="'https://support.vendasta.com/hc/en-us/articles/4406960330519'" target="_blank" rel="noopener">
          {{ 'COMMON.ACTION_LABELS.LEARN_MORE' | translate }}
        </a>
      </p>
      <p>
        <a [routerLink]="'/marketing/campaigns/acquire'" (click)="dialogRef.close()">
          {{ 'CUSTOMER_ACQUISITION_CAMPAIGNS.CAMPAIGN' | translate }}
        </a>
      </p>
      <p>
        <a [routerLink]="'/marketing/campaigns/adopt'" (click)="dialogRef.close()">
          {{ 'PRODUCT_ADOPTION_CAMPAIGNS.CAMPAIGN' | translate }}
        </a>
      </p>
      <p>
        <a [routerLink]="'/marketing/campaigns/upsell'" (click)="dialogRef.close()">
          {{ 'PRODUCT_UPSELL_CAMPAIGNS.CAMPAIGN' | translate }}
        </a>
      </p>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="(showSendFrom$ | async) && (selectedCampaign || selectedActionList)">
    <div class="modal-subheader">
      {{ 'CAMPAIGN_DETAILS.CONFIGURATION.SEND_FROM_TITLE' | translate }}
    </div>
    <mat-divider></mat-divider>
    <form [formGroup]="sendFromForm">
      <mat-form-field class="send-from" appearance="outline">
        <mat-select
          (selectionChange)="updateSendFromSelection($event)"
          [(value)]="selectedSendFrom"
          formControlName="sendFromSelector"
        >
          <mat-select-trigger>
            {{ selectedSendFromText$ | async }}
          </mat-select-trigger>
          <mat-option *ngIf="listType !== lt.UserList" [value]="sendFrom.assigned">
            {{ 'CAMPAIGN_DETAILS.CONFIGURATION.SEND_FROM.ASSIGNED_SALESPERSON' | translate }}
          </mat-option>
          <mat-option [value]="sendFrom.default" style="height: auto">
            <div>
              {{ 'CAMPAIGN_DETAILS.CONFIGURATION.SEND_FROM.DEFAULT_EMAIL' | translate }}
            </div>
            <ng-container *ngIf="defaultEmailAddress">
              <div class="default-email">{{ defaultEmailAddress }}</div>
            </ng-container>
          </mat-option>
          <mat-option [value]="sendFrom.custom">
            {{ 'CAMPAIGN_DETAILS.CONFIGURATION.SEND_FROM.CUSTOM_EMAIL' | translate }}
          </mat-option>
        </mat-select>
        <mat-hint>
          <ng-container *ngIf="selectedSendFrom === sendFrom.assigned">
            {{ sendFromDescription }}
          </ng-container>
          <ng-container *ngIf="selectedSendFrom === sendFrom.default">
            {{ 'CAMPAIGN_DETAILS.CONFIGURATION.SEND_FROM.DEFAULT_EMAIL_DESCRIPTION' | translate }}
          </ng-container>
        </mat-hint>
      </mat-form-field>
      <ng-container *ngIf="selectedSendFrom === sendFrom.custom">
        <div>
          <glxy-form-field class="custom-email" appearance="outline">
            <mat-label>{{ 'COMMON.NAME' | translate }}</mat-label>
            <input type="text" matInput formControlName="sendFromName" />
            <mat-error *ngIf="sendFromForm.controls.sendFromName.hasError('required')">
              {{ 'COMMON.THIS_FIELD_REQUIRED' | translate }}
            </mat-error>
          </glxy-form-field>
        </div>
        <div>
          <glxy-form-field class="custom-email" appearance="outline" [suffixText]="'@' + (senderInfoDomain$ | async)">
            <mat-label>
              {{ 'COMMON.EMAIL_ADDRESS' | translate }}
            </mat-label>
            <input type="text" matInput formControlName="sendFromEmail" />
            <mat-error *ngIf="sendFromForm.controls.sendFromEmail.hasError('required')">
              {{ 'COMMON.THIS_FIELD_REQUIRED' | translate }}
            </mat-error>
          </glxy-form-field>
        </div>
      </ng-container>
    </form>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-flat-button
    color="primary"
    class="addToCampaign"
    [disabled]="startCampaignButtonDisabled() || buttonLoading"
    (click)="addToCampaign()"
  >
    <glxy-button-loading-indicator [isLoading]="buttonLoading">
      {{ startCampaignText() }}
    </glxy-button-loading-indicator>
  </button>
  <button mat-button matDialogClose class="close-button" tabindex="-1" color="primary">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
